/**
 * Format a phone number string for display as (XXX) XXX-XXXX.
 * Handles 10-digit and 11-digit (leading 1) numbers.
 * Returns the original string if it doesn't match a known pattern.
 */
export function formatPhoneDisplay(number: string | undefined | null): string {
  if (!number) return '';
  const digits = number.replace(/\D/g, '');
  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  if (digits.length === 11 && digits[0] === '1') {
    return `(${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  }
  return number;
}
